// components/Logout.js
import React, { useState } from 'react';
import { useAuth } from '../common/AuthProvider';
import { useSubscription } from '../common/SubscriptionsProvider';
import { useHistory } from 'react-router-dom';
import '../styles.css'

const LogoutPage = () => {

    const { logout } = useAuth();
    const { setToInitialState } = useSubscription();
    const history = useHistory();
    const [error, setError] = useState('');

    const handleLogoutClick = async (e) => {
        e.preventDefault();
        const success = await logout();
        setToInitialState();
        if (!success) {
            setError('Logout failed');
            alert('Logout failed');
        }
    };

    return (
        <div className='logout-container'>
        <h3 className="text-center">Do you wish to logout?</h3>
            <div className='btn-group-custom'>
                <button className="btn-custom green" onClick={handleLogoutClick}>Logout</button>
                <button className="btn-custom blue"  onClick = {() => {history.push('/spaces');}}>Cancel</button>
            </div>
            {error && <div className="logout-error">{error}</div>}
        </div>
      );
}

export default LogoutPage;
